import React from 'react';
import MessageCircleMore from 'lucide-react/dist/esm/icons/message-circle-more';
import { tracking } from '../../../../../utils/tracking';

const LIGHT_INDIGO = '#8b9aff';
const GREEN = '#22c55e';

class ContactButton extends React.Component {
  render() {
    const { onClick, className, noContactIconClass, msgOpt, msgOptButton, customizeClassName } = this.props;
    return (
      <span className={className} style={{ marginRight: '0px' }}>
        {msgOptButton ? (
          <span
            className={`link ${!noContactIconClass ? 'imageClientState' : ''} ${customizeClassName}`}
            style={{
              position: 'relative',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer'
            }}
            onClick={() => {
              tracking('Click on Contact - Client');
              onClick();
            }}
          >
            <MessageCircleMore size={24} color={LIGHT_INDIGO} />
            {msgOpt && (
              <span
                style={{
                  position: 'absolute',
                  bottom: -1,
                  right: -1,
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  background: GREEN,
                  border: '1.5px solid #fff',
                  display: 'block'
                }}
              />
            )}
          </span>
        ) : (
          <img
            alt="contact"
            className={`link ${!noContactIconClass ? 'imageClientState' : ''} ${customizeClassName}`}
            src="img/chat_bubble_blue2.png"
            onClick={() => onClick()}
          />
        )}
      </span>
    );
  }
}

export default ContactButton;
